// src/guide/forums/guide_creer_forum.js
import {
  guide_tour_init,
  guide_tour_step_start,
  guide_tour_step,
  guide_tour_step_complete,
} from "@/guide/utils/guide_tour_actions";

export async function guide_creer_forum(langs) {
  let translations;
  try {
    // Charge dynamiquement le JSON correspondant (ex: guide_traduction_fr.json)
    translations = (
      await import(`@/guide/traductions/guide_traduction_${langs}.json`)
    ).default;
  } catch (error) {
    console.error(
      "Erreur lors du chargement des traductions pour la langue",
      langs,
      error
    );
    return;
  }
  const tour = guide_tour_init();

  guide_tour_step_start(
    tour,
    translations,
    translations.forums.nouveau_forum.sujet.titre,
    translations.forums.nouveau_forum.sujet.texte,
    "#sujet_new_forum",
    "bottom"
  );

  guide_tour_step(
    tour,
    translations,
    translations.forums.nouveau_forum.rubrique.titre,
    translations.forums.nouveau_forum.rubrique.texte,
    "#rubrique_new_forum"
  );
  guide_tour_step(
    tour,
    translations,
    translations.forums.nouveau_forum.type_ticket.titre,
    translations.forums.nouveau_forum.type_ticket.texte,
    "#radio"
  );

  guide_tour_step(
    tour,
    translations,
    translations.forums.nouveau_forum.pieces_jointes.titre,
    translations.forums.nouveau_forum.pieces_jointes.texte,
    "#file"
  );

  guide_tour_step(
    tour,
    translations,
    translations.forums.nouveau_forum.description.titre,
    translations.forums.nouveau_forum.description.texte,
    "#description_new_forum"
  );

  guide_tour_step_complete(
    tour,
    translations,
    translations.forums.nouveau_forum.valider_creation_forum.titre,
    translations.forums.nouveau_forum.valider_creation_forum.texte,
    "#click",
    "top"
  );

  tour.start();
}
